import { useState } from "react";
import "./LeaveSubscribeModal.css";

const REASONS = [
  "I want to talk to someone to understand the plan.",
  "I want other Payment options",
  "I find the preferred customer plan too expensive",
  "I am not interested anymore",
  "My reason is not listed",
];

export default function LeaveSubscribeModal({ open, onClose, onSubmit, isLoading }) {
  const [selected, setSelected] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!open) return null;

  return (
    <div className="leave-modal-overlay">
      <div className="leave-modal-container">
        <button onClick={onClose} className="leave-modal-close-btn" aria-label="Close">
          ×
        </button>
        <div className="leave-modal-title">
          Kindly share your reason for not becoming HomeShiksha's Preferred Customer?
        </div>
        <form
          onSubmit={async e => {
            e.preventDefault();
            if (selected && !isSubmitting) {
              setIsSubmitting(true);
              try {
                const finalReason = selected === "My reason is not listed" ? customReason : selected;
                await onSubmit(finalReason);
              } catch (error) {
                console.error("Error submitting feedback:", error);
                // Keep modal open on error so user can retry
              } finally {
                setIsSubmitting(false);
              }
            }
          }}
          className="leave-modal-form">
          <div className="leave-modal-reasons-container">
            {REASONS.map((reason, idx) => (
              <div key={reason} className="leave-modal-reason-item">
                <input
                  type="radio"
                  id={`reason-${idx}`}
                  name="leave-reason"
                  value={reason}
                  checked={selected === reason}
                  onChange={() => setSelected(reason)}
                  className="leave-modal-radio"
                  disabled={isSubmitting}
                  required
                />
                <label htmlFor={`reason-${idx}`}>{reason}</label>
              </div>
            ))}
          </div>

          {selected === "My reason is not listed" && (
            <div className="leave-modal-custom-reason">
              <div className="leave-modal-custom-reason-label">Kindly mention your reason below</div>
              <textarea
                value={customReason}
                onChange={e => setCustomReason(e.target.value)}
                placeholder="Type here"
                className="leave-modal-textarea"
                rows={2}
                disabled={isSubmitting}
                required
              />
            </div>
          )}

          <button
            type="submit"
            className="leave-modal-submit-btn"
            disabled={!selected || (selected === "My reason is not listed" && !customReason.trim()) || isLoading}>
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
